var _path, _path2, _path3, _text, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBerkshire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 373.333,
    height: 96,
    viewBox: "0 0 374.333 97"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004441",
    d: "M265.18 82.211c.014.293-141.858 4.816-192.047 1.527-10.729-.705-17.269-1.766-17.339-3.299-.351-7.763 209.087-4.856 209.386 1.772z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#217973",
    d: "M83.757 81.221c.523 1.178 2.517 1.758 4.453 1.295s3.082-1.793 2.559-2.969c-.524-1.178-2.518-1.756-4.453-1.295-1.936.463-3.082 1.791-2.559 2.969z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10.963 6.422h488.434v121.487H10.963z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(10.963 61.124)",
    fill: "#217973",
    fontFamily: "'BerkshireSwash-Regular'",
    fontSize: 72
  }, "Sus i serken")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#004441",
    cx: 319.687,
    cy: 81.649,
    r: 3.532
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#004441",
    cx: 332.888,
    cy: 81.676,
    r: 3.532
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#004441",
    cx: 345.404,
    cy: 81.649,
    r: 3.532
  })));
}
export default SvgLogoBerkshire;